export class Configuration {
  /**
   *
   */
  constructor() {
    this.setting = new Setting();
  }
  setting: Setting;
}
export class Setting {
  /**
   *
   */
  constructor() {
    this.TermsAndConditionsText = "";
    this.TermsAndConditionsLabel = "";
    this.TermsAndConditionsUrl = "";
    this.ImagingHospitalTitle = "";
    this.FooterTitle = "";
    this.FooterTitleHref = "";
    this.IsInternetAllow = false;
    this.PrivacyPolicyLabel = "";
    this.PrivacyPolicyUrl = "";
    this.CookiePolicyLabel = "";
    this.CookiePolicyUrl = "";
    this.AnonymousDisigit =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiYW5vbnltb3VzVG9rZW4iLCJzY29wZSI6InNpZ251cC5yZWFkIiwiZXhwIjoxOTEyNDM0ODQ5LCJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjUwMDAiLCJhdWQiOiJodHRwOi8vbG9jYWxob3N0OjQyMDAifQ.mVdAD-aH4pFK6KLu808CwS1Q7f6Acf07JXkPwxWW4ag";
  }

  TermsAndConditionsText: string;
  TermsAndConditionsLabel: string;
  TermsAndConditionsUrl: string;

  TermsAndConditions: string;
  ImagingHospitalTitle: string;
  FooterTitle: string;
  FooterTitleHref: string;
  IsInternetAllow: boolean;
  AnonymousDisigit: string;
  PrivacyPolicyLabel: string;
  PrivacyPolicyUrl: string;
  CookiePolicyLabel: string;
  CookiePolicyUrl: string;
}
